import AppForm from '../app-components/Form/AppForm';

Vue.component('app-prices-factory-form', {
    mixins: [AppForm],
    data: function() {
        return {
            form: {
                app_factories_id:  '' ,
                name:  '' ,
                price:  '' ,
                enabled:  false ,
                
            },
            factory_selected: ''
        }
    },
    methods:{
        onSelect(appFactorySelected) {
            if (appFactorySelected !== null) {
                this.form.app_factories_id = appFactorySelected.id;
            }else{
                this.form.app_factories_id = null;
            }
        },
        onRemove(appFactorySelected) {
            this.form.app_factories_id = null;
        },
    },
    props: {
        appFactorySelected: {
            type: Object,
            default: {}
        }
    },
    mounted: function () {  
        this.factory_selected = this.appFactorySelected
    }

});